import type { LookupTableOption } from "../../Components/DataEntry/Select/LookupTableSelect";

export type LookupPath = string | number | Array<string | number>;

const toPath = (path: LookupPath): Array<string | number> =>
  Array.isArray(path) ? path : [path];

const getByPath = (source: any, path: LookupPath) =>
  toPath(path).reduce((value, key) => (value == null ? value : value[key]), source);

export const normalizeLookupText = (value: any) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  return "";
};

export const getLookupTableText = (
  option: LookupTableOption,
  dataIndex: LookupPath,
) => {
  const directValue = getByPath(option, dataIndex);
  const rawValue = getByPath(option.raw, dataIndex);

  return normalizeLookupText(directValue ?? rawValue);
};

const getLookupObjectId = (value: any) => {
  if (!value || typeof value !== "object") return undefined;

  return value.raw?._id ?? value._id ?? value.value ?? value.key;
};

const getPrimitiveLookupId = (value: any) => {
  if (typeof value !== "string" && typeof value !== "number") return undefined;
  if (value === "") return undefined;

  return value;
};

export const getLookupTablePayloadId = (value: any, fallback?: any) => {
  const directId = getLookupObjectId(value);
  if (directId !== undefined && directId !== null && directId !== "") {
    return directId;
  }

  const fallbackId = getLookupObjectId(fallback) ?? getPrimitiveLookupId(fallback);
  if (fallbackId !== undefined && fallbackId !== null && fallbackId !== "") {
    return fallbackId;
  }

  return getPrimitiveLookupId(value);
};

export const formatLookupCurrency = (value: any) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "";

  return `${amount.toLocaleString("vi-VN")}đ`;
};

export const formatLookupDistance = (value: any) => {
  const distance = Number(value);
  if (!Number.isFinite(distance)) return "";

  return `${distance.toLocaleString("vi-VN")} km`;
};
